export default class TrainerEditController {
    constructor($routeParams, $location, $mdDialog, userService, notificationsService, globalConstants) {
        this.form = {};
        this.$location = $location;
        this.userService = userService;
        this.$routeParams = $routeParams;
        this.$mdDialog = $mdDialog;
        this.imageData = undefined;
        this.notificationsService = notificationsService;
        this.globalConstants = globalConstants;
                
        this.userService.get($routeParams.id).then(resp => {
            this.form.id = resp.data.id;
            this.form.name = resp.data.name;
            this.form.email = resp.data.email; 
            this.form.password = resp.data.password;
            this.form.confirmpassword = resp.data.password;
            this.form.imageType = resp.data.imageType;
            this.form.icon = resp.data.icon;
        }, error => {
            $location.path("/");
        });
    }
    
    onSave() { 

        var that = this;

        if(this.form.name == undefined || this.form.name.length < 1 || 
            this.form.email == undefined || this.form.email.length < 1){
            this.notificationsService.show("Please enter a name and email", "error");
            return;
        }

        if(this.form.password != undefined && this.form.password.length > 0 && 
            (this.form.confirmpassword == undefined || this.form.confirmpassword.length < 1 || this.form.confirmpassword != this.form.password)){
            this.notificationsService.show("Please enter confirm the password", "error");
            return;
        }

        if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)){
            this.notificationsService.show("Please enter a valid email address", "error");
            return;
        }

        if(that.imageData != undefined) {
            that.form.image = that.imageData.image;
            that.form.imagetype = that.imageData.imagetype;
        }

        that.userService.updateTrainer(that.form).then(resp => {
            that.$location.path(`/manage`);
            that.notificationsService.show("Trainer updated", "success");
        }, resp => {
            that.notificationsService.show(resp.data, "error");
        });
    }

    clearImageUpload() {
        document.getElementById('file').value = null;
        this.imageData = undefined;
    }

    goBack(){ 
        this.$location.path(`/manage`);
    }

    delete(){
        this.userService.delete(this.$routeParams.id).then(resp => {
            this.$location.path(`/manage`);
            this.notificationsService.show("Trainer deleted", "success");
        });
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteUserDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteUserDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
}


// WEBPACK FOOTER //
// ./src/js/components/trainers/trainers.edit.controller.js